module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no_collections_found":"No collections found","actions":{"create":"new..."}}}')
  delete Component.options._Ctor
}
